// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.90.0-beta.4a13ccb77',
  revision: '4a13ccb77',
  branch: 'develop',
  date: 'Sat, 08 Aug 2026 12:40:04 GMT'
};